<template>
  <div>
    <div class="wrapper">
      <breadcrumb :crumbs="[$t('menu.sizes'), $t('text.list')]">
        <el-button type="success" size="mini" @click="add"
          >+ {{ $t("text.create") }}</el-button
        >
      </breadcrumb>
    </div>
    <div class="wrapper table-area">
      <sticky
        :sticky-top="62"
        :viewport="1024"
        :is-rem="false"
        style="min-height: 52px"
      >
        <vxe-toolbar ref="recordsToolbar" custom zoom class="table-toolbar">
          <template v-slot:buttons>
            <el-button type="primary" size="mini" @click="batchSetCategory">
              {{ $t("action.setCategory") }}
            </el-button>
          </template>
        </vxe-toolbar>
      </sticky>
      <vxe-table
        :data="records"
        @checkbox-change="setSelected"
        @checkbox-all="setSelected"
        :checkbox-config="{ reserve: true }"
        :loading="loading"
        id="sizeTable"
        row-id="id"
        ref="recordsTable"
        class="recordsTable"
        size="mini"
        resizable
        highlight-hover-row
        auto-resize
        :scroll-y="{ enabled: false }"
      >
        <vxe-table-column
          field="checkbox"
          type="checkbox"
          width="35"
        ></vxe-table-column>
        <vxe-table-column width="60px">
          <template v-slot="{ row, rowIndex }">
            <i
              v-if="rowIndex != 0"
              class="el-icon-top mgr10"
              @click="swapSequence(row, rowIndex, 'up')"
            ></i>
            <i
              v-if="
                rowIndex + 1 !=
                (pager.pageSize > pager.total ? pager.total : pager.pageSize)
              "
              class="el-icon-bottom"
              @click="swapSequence(row, rowIndex, 'down')"
            ></i>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="sequence"
          :title="$t('text.sequence')"
          width="100"
        />
        <vxe-table-column
          field="name"
          :title="$t('text.name')"
          min-width="140"
        />
        <vxe-table-column
          field="explain"
          :title="$t('text.explain')"
          min-width="200"
        >
        </vxe-table-column>
        <vxe-table-column :title="$t('menu.categories')" min-width="200">
          <template v-slot="{ row }">
            <span v-if="row.categories != null">
              <span v-if="row.categories.length > 10">
                <el-popover placement="top-start" trigger="hover" width="600">
                  <div>
                    {{ row.categories.map((s) => s.name).join("，") }}
                  </div>
                  <span slot="reference">
                    {{
                      row.categories
                        .slice(0, 10)
                        .map((s) => s.name)
                        .join("，") + "..."
                    }}</span
                  >
                </el-popover>
              </span>
              <span v-else>
                {{ row.categories.map((s) => s.name).join("，") }}
              </span>
            </span>
          </template>
        </vxe-table-column>

        <vxe-table-column :title="$t('text.action')" width="150" fixed="right">
          <template v-slot="{ row }">
            <el-button type="text" size="mini" @click="edit(row)">{{
              $t("text.edit")
            }}</el-button>
            <el-popconfirm
              :title="$t('prompt.confirmDelete')"
              @confirm="deleteRow(row)"
              class="mgl10 mgr10"
            >
              <el-button slot="reference" type="text" size="mini">
                {{ $t("text.delete") }}
              </el-button>
            </el-popconfirm>
            <el-button type="text" size="mini" @click="editCategory(row)">
              {{ $t("action.setCategory") }}
            </el-button>
          </template>
        </vxe-table-column>
      </vxe-table>
      <div class="flex flex-between pager">
        <div class="selected-qty-tips"></div>
        <div>
          <vxe-pager
            size="small"
            :loading="false"
            :background="false"
            :current-page="pager.currentPage"
            :page-size="pager.pageSize"
            :total="pager.total"
            :layouts="pagerConfig.layouts"
            :page-sizes="pagerConfig.pageSizes"
            @page-change="changePager"
          ></vxe-pager>
        </div>
      </div>
    </div>
    <!-- 新增 -->
    <el-dialog
      :title="$t('text.create')"
      :close-on-click-modal="false"
      :visible.sync="addDF"
      width="40%"
    >
      <el-form ref="addObjForm" :model="addObj">
        <div v-for="(item, index) in addObj.items" :key="index">
          <el-row :gutter="5">
            <el-col :span="6">
              <el-form-item>
                <el-input
                  size="small"
                  v-model.trim="item.name"
                  :placeholder="$t('text.name')"
                  @blur="existJudge(index)"
                />
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item>
                <el-input
                  size="small"
                  v-model.trim="item.explain"
                  :placeholder="$t('text.explain')"
                  @blur="existJudge(index)"
                />
              </el-form-item>
            </el-col>
            <el-col v-if="item._invExist || item._localRepeat" :span="6">
              <el-form-item>
                <small v-if="item._invExist" class="red">{{
                  $t("rules.exist", [$t("text.name")])
                }}</small>
                <small v-if="item._localRepeat" class="red">{{
                  $t("rules.filledIn", [$t("text.name")])
                }}</small>
              </el-form-item>
            </el-col>
            <el-col :span="2">
              <el-form-item>
                <i
                  v-if="index"
                  class="el-icon-delete red"
                  @click="remove(index)"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <div>
          <el-row>
            <el-col :span="20">
              <el-button
                type="success"
                plain
                icon="el-icon-plus"
                size="mini"
                @click="addMore"
                >{{ $t("text.more") }}</el-button
              >
            </el-col>
          </el-row>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="saveDoing"
          size="small"
          @click="addSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="addDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
    <!-- 编辑 -->
    <el-dialog
      :title="$t('text.edit')"
      :close-on-click-modal="false"
      :visible.sync="editDF"
      width="30%"
    >
      <el-form ref="editObjForm" :model="editObj" label-width="60px">
        <el-form-item
          :label="$t('text.name')"
          :prop="'name'"
          :rules="[
            { required: true, validator: validateNameEdit, trigger: 'blur' },
          ]"
        >
          <el-input
            size="small"
            v-model.trim="editObj.name"
            :placeholder="$t('text.name')"
          />
        </el-form-item>
        <el-form-item
          :label="$t('text.sequence')"
          :prop="'sequence'"
          :rules="[
            {
              required: true,
              validator: validateSequenceEdit,
              trigger: 'blur',
            },
          ]"
        >
          <el-input
            size="small"
            v-model.trim="editObj.sequence"
            :placeholder="$t('text.sequence')"
          />
        </el-form-item>

        <el-form-item :prop="'explain'" :label="$t('text.explain')">
          <el-input
            size="small"
            v-model.trim="editObj.explain"
            :placeholder="$t('text.explain')"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="editDoing"
          size="small"
          @click="editSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="editDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>

    <!-- 编辑 -->
    <el-dialog
      :title="$t('action.setCategory')"
      :close-on-click-modal="false"
      :visible.sync="setCategoryDF"
      width="40%"
    >
      <el-form>
        <el-form-item :prop="'checkedCategoryIds'">
          <el-checkbox-group size="small" v-model="checkedCategoryIds">
            <el-checkbox
              style="width: 20%"
              v-for="category in categories"
              :key="category.id"
              :label="category.id"
            >
              <raw-html-limit-number :content="category.name" :number="8" />
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="setCategoryDoing"
          size="small"
          @click="setCategorySubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="setCategoryDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { page, table } from "@/utils/mixins.js";
import Util from "@/utils";
import RawHtmlLimitNumber from "@/components/RawHtmlLimitNumber";
import Size from "@/api/size.js";
import Category from "@/api/category.js";

function build() {
  return {
    name: null,
    explain: null,
    _invExist: false,
    _localRepeat: false,
  };
}
export default {
  mixins: [
    page,
    table.pager,
    table.narrow,
    table.search,
    table.checker,
    table.sorter,
    table.basic,
  ],
  components: { RawHtmlLimitNumber },
  data() {
    var validateNameEdit = (rule, value, callback) => {
      const self = this;
      if (value == null) {
        callback(new Error(self.$t("rules.required", [this.$t("text.name")])));
        return;
      }
      Size.findByName({ name: value }).then(function (res) {
        if (res.data.code === 200 && res.data.entity.id !== self.row.id) {
          callback(new Error(self.$t("rules.exist", [this.$t("text.name")])));
        } else {
          callback();
        }
      });
    };
    var validateSequenceEdit = (rule, value, callback) => {
      const self = this;
      if (value === null || value === "") {
        callback(
          new Error(this.$t("rules.required", [this.$t("text.sequence")]))
        );
        return;
      }
      if (!Util.regexQuantity(value)) {
        callback(new Error(this.$t("rules.regex", [this.$t("text.sequence")])));
        return;
      }
      Size.findBySequence({ sequence: value }).then(function (res) {
        if (res.data.code === 200 && res.data.entity.id != self.row.id) {
          callback(
            new Error(self.$t("rules.exist", [self.$t("text.sequence")]))
          );
        } else {
          callback();
        }
      });
    };
    return {
      sorter: {
        sortBy: "size_sequence",
        sortIndicator: "asc",
      },
      // 新增
      addDF: false,
      addObj: {
        items: [],
      },
      saveDoing: false,
      // 编辑
      validateNameEdit: validateNameEdit,
      validateSequenceEdit: validateSequenceEdit,
      editDF: false,
      row: null,
      editObj: {
        name: null,
        explain: null,
        sequence: null,
      },
      editDoing: false,
      //
      setCategoryDF: false,
      categories: [],
      checkedCategoryIds: [],
      setCategoryDoing: false,
      setCategoryType: null,
    };
  },
  created() {
    const self = this;
  },
  methods: {
    //
    swapSequence(row, rowIndex, type) {
      const self = this;
      const obj = {
        swapId: row.id,
        swapId2:
          type == "up"
            ? self.records[rowIndex - 1].id
            : self.records[rowIndex + 1].id,
      };
      Size.swapSequence(obj).then(function (res) {
        if (res.status == 200) {
          self.loadData();
        } else {
          self.sysError();
        }
      });
    },
    //编辑分类
    batchSetCategory() {
      const self = this;
      if (this.selectRecords.length === 0) {
        this.$message.error(this.$t("prompt.atLeastSelectOneData"));
        return;
      }
      self.setCategoryType = "batch";
      Category.productCategory().then(function (res) {
        if (res.status == 200) {
          self.categories = res.data;
          const categoryIds = self.categories.map((c) => c.id);
          self.checkedCategoryIds = [];
          self.setCategoryDF = true;
        } else {
          self.sysError();
        }
      });
    },

    editCategory(row) {
      const self = this;
      self.row = row;
      self.setCategoryType = "row";
      Category.productCategory().then(function (res) {
        if (res.status == 200) {
          self.categories = res.data;
          const categoryIds = self.categories.map((c) => c.id);
          self.checkedCategoryIds = row.categories
            .filter((c) => categoryIds.includes(c.id))
            .map((c) => c.id);
          self.setCategoryDF = true;
        } else {
          self.sysError();
        }
      });
    },
    setCategorySubmit() {
      const self = this;
      if (self.setCategoryType == "row") {
        self.setCategoryDoing = true;
        Size.updateCategory(self.row.id, {
          categoryIds: self.checkedCategoryIds,
        }).then(function (res) {
          self.setCategoryDoing = false;
          if (res.status == 200) {
            self.$message({
              message: self.$t("prompt.editSuccess"),
              type: "success",
            });
            self.setCategoryDF = false;
            self.loadData();
          } else {
            self.sysError();
          }
        });
      } else {
        const data = this.selectRecords.map((r) => {
          return {
            id: r.id,
            categoryIds: self.checkedCategoryIds,
          };
        });
        self.setCategoryDoing = true;
        Size.batchUpdateCategory(data).then(function (res) {
          self.setCategoryDoing = false;
          if (res.status == 200) {
            self.$message({
              message: self.$t("prompt.editSuccess"),
              type: "success",
            });
            self.setCategoryDF = false;
            self.loadData();
          } else {
            self.sysError();
          }
        });
      }
    },
    // 删除
    deleteRow(row) {
      const self = this;
      if (confirm(this.$t("prompt.confirmDelete"))) {
        Size.delete(row.id).then(function (res) {
          if (res.status === 200) {
            self.$message({
              message: self.$t("prompt.delSuccess"),
              type: "success",
            });
            self.loadData();
          } else {
            self.sysError();
          }
        });
      }
    },
    // 编辑
    edit(row) {
      const self = this;
      self.row = row;
      self.editObj.name = row.name;
      self.editObj.explain = row.explain;
      self.editObj.sequence = row.sequence;
      self.editDoing = false;
      self.editDF = true;
    },

    editSubmit() {
      const self = this;
      self.$refs.editObjForm.validate((valid) => {
        if (valid) {
          self.editDoing = true;
          Size.update(self.row.id, self.editObj).then(function (res) {
            if (res.status === 200) {
              self.editDoing = false;
              self.editDF = false;
              self.$message({
                message: self.$t("prompt.editSuccess"),
                type: "success",
              });
              self.loadData();
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },
    // 新增
    add() {
      this.addObj.items = [build(), build(), build()];
      this.saveDoing = false;
      this.addDF = true;
    },
    remove(idx) {
      this.addObj.items.splice(idx, 1);
    },
    addMore() {
      this.addObj.items.push(build());
    },
    existJudge(idx) {
      const self = this;
      this.addObj.items[idx]._invExist = false;
      this.addObj.items[idx]._localRepeat = false;
      if (
        this.addObj.items[idx].name != null &&
        this.addObj.items[idx].name !== ""
      ) {
        Size.findByName({ name: self.addObj.items[idx].name }).then(function (
          res
        ) {
          if (res.data.code === 200) {
            self.addObj.items[idx]._invExist = true;
          } else {
            // 本地过滤
            const iis = self.addObj.items.filter(function (s) {
              return (
                (s.name || "").trim() === self.addObj.items[idx].name.trim()
              );
            });
            if (iis.length > 1) {
              this.addObj.items[idx]._localRepeat = true;
            }
          }
        });
      }
    },

    addSubmit() {
      const self = this;
      const items = this.addObj.items.filter(function (item) {
        return item.name !== null && item.name.trim() !== "";
      });

      if (items.length === 0) {
        self.$message({
          message: this.$t("prompt.atLeastOneValidDataFillIn"),
          type: "warning",
        });
        return;
      }

      const errDatas = items.filter(
        (s) => s._invExist === true || s._localRepeat === true
      );
      if (errDatas.length !== 0) {
        self.$message({
          message: this.$t("prompt.errorMessage"),
          type: "warning",
        });
        return;
      }

      self.saveDoing = true;
      Size.insertBatch(items).then(function (res) {
        self.saveDoing = false;
        self.addDF = false;
        if (res.status === 200) {
          self.$message({
            message: self.$t("prompt.addSuccess"),
            type: "success",
          });
          self.loadData();
        } else {
          self.sysError();
        }
      });
    },
    dataProvider(params) {
      return Size.search(params);
    },
  },
};
</script>
<style scoped>
</style>